export default __webpack_public_path__ + "static/media/biodata-11.f983af51.png";